import React from 'react';

import { SvgIconProps } from '@mui/material';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons16px/Arrow.svg';
import { ReactComponent as AttachmentIcon } from '../../../../assets/icons16px/Attachment.svg';
import { ReactComponent as ChatBubbleIcon } from '../../../../assets/icons16px/ChatBubble.svg';
import { ReactComponent as CollapseIcon } from '../../../../assets/icons16px/Collapse.svg';
import { ReactComponent as ColumnChartIcon } from '../../../../assets/icons16px/ColumnChart.svg';
import { ReactComponent as CreditCardIcon } from '../../../../assets/icons16px/CreditCard.svg';
import { ReactComponent as FilterIcon } from '../../../../assets/icons16px/Filter.svg';
import { ReactComponent as LineChartIcon } from '../../../../assets/icons16px/LineChart.svg';
import { ReactComponent as LogOutIcon } from '../../../../assets/icons16px/LogOut.svg';
import { ReactComponent as NotificationsIcon } from '../../../../assets/icons16px/Notifications.svg';
import { ReactComponent as PencilIcon } from '../../../../assets/icons16px/Pencil.svg';
import { ReactComponent as PieChartIcon } from '../../../../assets/icons16px/PieChart.svg';
import { ReactComponent as PinIcon } from '../../../../assets/icons16px/Pin.svg';
import { ReactComponent as PricingIcon } from '../../../../assets/icons16px/Pricing.svg';
import { ReactComponent as QuarterlyReportsIcon } from '../../../../assets/icons16px/QuarterlyReports.svg';
import { ReactComponent as SettingsIcon } from '../../../../assets/icons16px/Settings.svg';
import { ReactComponent as StarIcon } from '../../../../assets/icons16px/Star.svg';

export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'SETTINGS' |
  'COLUMNCHART' |
  'LINECHART' |
  'NOTIFICATIONS' |
  'COLLAPSE' |
  'CHATBUBBLE' |
  'CREDITCARD' |
  'ARROW' |
  'STAR' |
  'ATTACHMENT' |
  'PIECHART' |
  'PIN' |
  'PRICING' |
  'QUARTERLYREPORTS' |
  'PENCIL' |
  'LOGOUT' |
  'FILTER';



export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  SETTINGS: <SettingsIcon />,
  COLUMNCHART: <ColumnChartIcon />,
  LINECHART: <LineChartIcon />,
  NOTIFICATIONS: <NotificationsIcon />,
  COLLAPSE: <CollapseIcon />,
  CHATBUBBLE: <ChatBubbleIcon />,
  CREDITCARD: <CreditCardIcon />,
  ARROW: <ArrowIcon />,
  STAR: <StarIcon />,
  ATTACHMENT: <AttachmentIcon />,
  PIECHART: <PieChartIcon />,
  PIN: <PinIcon />,
  PRICING: <PricingIcon />,
  QUARTERLYREPORTS: <QuarterlyReportsIcon />,
  FILTER: <FilterIcon />,
  PENCIL: <PencilIcon />,
  LOGOUT: <LogOutIcon />
};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const Res = __icon2iconUrl[props.icon];

  return (

    <Res.type {...props} />

  );
};
